export function subjectIdFromName(subject_name: string): number {
  const subjectMappings: { [name: string]: number } = {
    english: 1,
    mathematics: 2,
    science: 3,
    'chinese-id:4': 4,
    malay: 5,
    tamil: 6,
    'e-math': 7,
    'a-math': 8,
    'physics-old': 9,
    'chemistry-old': 10,
    'biology-old': 11,
    'h2-math': 15,
    'h1-math': 16,
    'h3-math': 17,
    'h2-physics': 18,
    'chinese-c2': 19,
    chinese: 20,
    'no-subject': 22,
    investment: 23,
    'combined-science-physics': 24,
    'foundation-mathematics': 25,
    'young-learners-english': 26,
    'vietnam-mathematics': 27,
    'combined-science-chemistry': 28,
    'combined-science-physics-na': 29,
    'combined-science-chemistry-na': 30,
    'chinese-tutorial': 31,
    chemistry: 35,
    physics: 36,
    'combined-chemistry-o-level': 37,
    'combined-physics-o-level': 38,
    'combined-chemistry-na-level': 39,
    'combined-physics-na-level': 40,
    'young-learner': 41,
    biology: 42,
    'tss-practice': 51,
    'h2-chemistry': 54,
    'h2-biology': 55,
    'english-psle': 56,
    'psle-camp': 57,
  };
  const subjectId = subjectMappings[subject_name];
  return subjectId !== undefined ? subjectId : 0;
}
